import { observer } from 'mobx-react-lite';
import * as React from 'react';

import { useTestSubmissionStore } from '../../model/test-submissions.hook';
import { BottomNavigationLeftInfo } from '../BottomLeftInfo';
import { ButtonQuestionNavigation } from './ButtonQuestionNavigation';

interface BottomNavigationProps extends React.HTMLAttributes<HTMLDivElement> {
  disableTestInfo?: boolean;
  disableSubmitAction?: boolean;
  onSubmitWithEvents?: () => void;
}

export const SectionInfoListeningFullTest = observer((props: BottomNavigationProps) => {
  const { disableTestInfo, disableSubmitAction, onSubmitWithEvents, children } = props;
  const store = useTestSubmissionStore();

  if (disableTestInfo) {
    return (
      <div className="all-section-info reading-view-only">
        <div className="section-right">
          <ButtonQuestionNavigation
            disableSubmitAction={disableSubmitAction}
            onSubmitWithEvents={onSubmitWithEvents}
            enableEvent
          />
        </div>
      </div>
    );
  }
  return (
    <div className="all-section-info">
      <div className="section-left">
        <BottomNavigationLeftInfo
          title={store.name}
          desc={store.desc}
          bookCover={store.bookCover}
        />
      </div>
      <div className="section-middle">{children}</div>
      <div className="section-right">
        <ButtonQuestionNavigation
          disableSubmitAction={disableSubmitAction}
          onSubmitWithEvents={onSubmitWithEvents}
          enableEvent
        />
      </div>
    </div>
  );
});
